import { Component, signal, Signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PrescriptionService } from '../../services/prescription.service';
import { PatientService } from '../../services/patient.service';
import { Prescription } from '../../models/prescription.model';
import { Patient } from '../../models/patient.model';
import { ButtonComponent, InputComponent } from '../ui';

@Component({
  selector: 'app-prescriptions',
  imports: [CommonModule, FormsModule, DatePipe, ButtonComponent,],
  templateUrl: './prescriptions.component.html',
  styleUrl: './prescriptions.component.css'
})
export class PrescriptionsComponent {
  prescriptions!: Signal<Prescription[]>;
  patients!: Signal<Patient[]>;
  showModal = signal(false);
  editingPrescription = signal<Prescription | null>(null);
  prescriptionForm = signal<Partial<Prescription>>({});

  constructor(
    private prescriptionService: PrescriptionService,
    private patientService: PatientService
  ) {
    this.prescriptions = this.prescriptionService.getPrescriptions();
    this.patients = this.patientService.getPatients();
  }

  openAddModal() {
    this.editingPrescription.set(null);
    this.prescriptionForm.set({
      patientId: '',
      patientName: '',
      doctorId: '1',
      doctorName: 'Dr. Sarah Williams',
      date: new Date(),
      medications: [{
        name: '',
        dosage: '',
        frequency: '',
        duration: '',
        quantity: 1,
        refills: 0
      }],
      status: 'Active'
    });
    this.showModal.set(true);
  }

  openEditModal(prescription: Prescription) {
    this.editingPrescription.set(prescription);
    this.prescriptionForm.set({ ...prescription });
    this.showModal.set(true);
  }

  closeModal() {
    this.showModal.set(false);
    this.editingPrescription.set(null);
  }

  onPatientSelect(patientId: string) {
    const patient = this.patients().find((p: Patient) => p.id === patientId);
    if (patient) {
      this.prescriptionForm().patientName = `${patient.firstName} ${patient.lastName}`;
    }
  }

  addMedication() {
    const medications = this.prescriptionForm().medications || [];
    medications.push({
      name: '',
      dosage: '',
      frequency: '',
      duration: '',
      quantity: 1,
      refills: 0
    });
    this.prescriptionForm().medications = medications;
  }

  removeMedication(index: number) {
    const medications = this.prescriptionForm().medications || [];
    medications.splice(index, 1);
    this.prescriptionForm().medications = medications;
  }

  getMedicationNames(medications: any[]): string {
    return medications.map(m => m.name).join(', ');
  }

  onDateChange(value: string) {
    this.prescriptionForm().date = new Date(value);
  }

  savePrescription() {
    const form = this.prescriptionForm();
    if (this.editingPrescription()) {
      this.prescriptionService.updatePrescription(this.editingPrescription()!.id, form);
    } else {
      this.prescriptionService.addPrescription(form as Omit<Prescription, 'id' | 'createdAt' | 'updatedAt'>);
    }
    this.closeModal();
  }

  deletePrescription(id: string) {
    if (confirm('Are you sure you want to delete this prescription?')) {
      this.prescriptionService.deletePrescription(id);
    }
  }
}

